import { intervalToSeconds } from '@/common/utils/intervalToSeconds'
import { unFormatUnit } from '@/common/utils/unFormatters'
import { CompanyBranchValidationSchema } from '@/features/companyBranches/schemas/companyBranch.schema'

const parseConsumptionRestriction = (
  productCategoryRestriction: CompanyBranchValidationSchema['product_category_restrictions_attributes'][number],
) => {
  const minimum_kilometers_usage_between_consumptions =
    productCategoryRestriction.minimum_kilometers_usage_between_consumptions
      ? unFormatUnit(productCategoryRestriction.minimum_kilometers_usage_between_consumptions, 'Km') || ''
      : ''
  const maximum_kilometers_usage_between_consumptions =
    productCategoryRestriction.maximum_kilometers_usage_between_consumptions
      ? unFormatUnit(productCategoryRestriction.maximum_kilometers_usage_between_consumptions, 'Km') || ''
      : ''
  const minimum_seconds_usage_between_consumptions =
    productCategoryRestriction.minimum_seconds_usage_between_consumptions
      ? intervalToSeconds({
          days: Number(productCategoryRestriction.minimum_seconds_usage_between_consumptions?.days || 0),
          hours: Number(productCategoryRestriction.minimum_seconds_usage_between_consumptions?.hours || 0),
          minutes: Number(productCategoryRestriction.minimum_seconds_usage_between_consumptions?.minutes || 0),
          seconds: Number(productCategoryRestriction.minimum_seconds_usage_between_consumptions?.seconds || 0),
        }) || ''
      : ''
  const maximum_seconds_usage_between_consumptions =
    productCategoryRestriction.maximum_seconds_usage_between_consumptions
      ? intervalToSeconds({
          days: Number(productCategoryRestriction.maximum_seconds_usage_between_consumptions?.days || 0),
          hours: Number(productCategoryRestriction.maximum_seconds_usage_between_consumptions?.hours || 0),
          minutes: Number(productCategoryRestriction.maximum_seconds_usage_between_consumptions?.minutes || 0),
          seconds: Number(productCategoryRestriction.maximum_seconds_usage_between_consumptions?.seconds || 0),
        }) || ''
      : ''

  return {
    minimum_kilometers_usage_between_consumptions,
    maximum_kilometers_usage_between_consumptions,
    minimum_seconds_usage_between_consumptions,
    maximum_seconds_usage_between_consumptions,
  }
}

export const transformNewProductCategoryRestrictions = (
  productCategoryRestriction: CompanyBranchValidationSchema['product_category_restrictions_attributes'][number],
) => ({
  product_category_id: productCategoryRestriction.product_category_id,
  ...parseConsumptionRestriction(productCategoryRestriction),
})

export const transformUpdatedProductCategoryRestrictions = (
  productCategoryRestriction: CompanyBranchValidationSchema['product_category_restrictions_attributes'][number],
) => ({
  id: productCategoryRestriction.id,
  ...parseConsumptionRestriction(productCategoryRestriction),
})
